import { onAuthStateChanged } from 'firebase/auth';
import axios from 'utils/axios';
import { auth } from '../../../firebase';
import { v4 as uuidv4 } from 'uuid';

/**
 * Updates a simulation's editable tick-prompt templates. A null field leaves
 * that role's template unchanged; an empty string clears it back to the
 * built-in default. Takes effect on the very next tick, including while
 * running. Response echoes `{ simulationId, sellerTemplate, buyerTemplate }`.
 */
const setSimulationTickPromptTemplates = (
  simulationId,
  { sellerTemplate, buyerTemplate },
  callback,
  errorCallback,
) => {
  return async (dispatch) => {
    try {
      let unsubscribe = onAuthStateChanged(auth, async (user) => {
        const token = await user?.getIdToken();
        const reqId = uuidv4();
        try {
          const response = await axios.patch(
            `/ads/admin/simulations/${simulationId}/tick-prompt-template`,
            { sellerTemplate, buyerTemplate },
            {
              params: {
                'request-id': reqId,
              },
              headers: {
                Authorization: `Bearer ${token}`,
              },
            },
          );
          if (response.status === 200) {
            if (typeof callback === 'function') callback(response?.data);
          } else {
            if (typeof errorCallback === 'function')
              errorCallback('Failed to update tick prompt');
          }
        } catch (e) {
          if (typeof errorCallback === 'function')
            errorCallback(
              e?.response?.data?.message || 'Failed to update tick prompt',
            );
        }
        unsubscribe();
      });
    } catch (e) {
      if (typeof errorCallback === 'function')
        errorCallback('Failed to update tick prompt');
    }
  };
};

export default setSimulationTickPromptTemplates;
